function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("path", {
  d: "M451.023 0C318.445 92.3887 -141.326 152.797 49.8912 403.312C56.5057 205.386 236.514 204.705 328.644 145.69C243.766 210.431 78.1455 211.351 71.1906 427.315C356.703 521.423 474.817 195.425 451.023 0Z",
  fill: "#188072"
}), React.createElement("path", {
  d: "M86.7106 416.453C89.5459 370.167 100.262 335.532 115.466 308.7C131.875 279.742 154.026 258.964 179.027 242.268C203.45 225.957 230.174 213.784 257.091 201.523C257.996 201.111 258.902 200.698 259.807 200.286C287.103 187.846 314.953 174.998 337.741 157.616L320.553 133.059C299.045 146.836 272.022 157.429 241.79 168.997C240.647 169.435 239.5 169.874 238.349 170.314C209.615 181.301 178.513 193.194 149.84 209.338C119.83 226.235 91.7519 248.162 70.8067 279.527C55.9494 301.775 45.0158 328.271 39.2732 360.222C15.0398 316.704 14.682 282.126 27.025 253.548C43.1896 216.122 82.917 184.237 136.147 155.565C186.134 128.64 245.203 105.976 301.498 84.3776C304.643 83.1712 307.778 81.9682 310.903 80.7678C358.317 62.5562 404.035 44.7242 438.259 25.5441C443.654 116.82 419.747 230.508 364.583 313.961C334.7 359.17 296.11 394.827 248.756 413.807C204.111 431.701 150.421 435.283 86.7106 416.453Z",
  stroke: "#188072",
  strokeWidth: 30
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 458,
  height: 452,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgLeafFilled = function SvgLeafFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 458 452",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLeafFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/leaf-filled.aa412cdf.svg";
export { ForwardRef as ReactComponent };